import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/scss/global.scss";
// import Utils from "./components/Utils";

createApp(App).use(store).use(router).mount("#app");

(<any>window).setTrophyCount = async (count: number) => {
  const el = document.querySelector<HTMLElement>(
    "header[data-id='park-header'] .current"
  );
  if (el) el.innerText = count >= 100 ? "100" : ("00" + count).slice(-2);

  const medal = document.querySelector<HTMLElement>(
    "header[data-id='park-header'] .medal"
  );

  const point = document.querySelector<HTMLElement>(
    "header[data-id='park-header'] .point"
  );

  const toZenkaku = (char: number) =>
    String.fromCharCode(char.toString().charCodeAt(0) + 0xfee0);

  const next = (num: number) => {
    const x = num - count;
    return x < 10 ? toZenkaku(x) : x;
  };

  // const lotteryCount = await Utils.getRemainingLotteryTimes();

  let str = `あと${next(
    5
  )}個で一条ブロンズマイスター<br>トロフィーは、パビリオンへの入場や<br class="mobile">クイズに挑戦、ジョーくんを見つけると<br class="mobile">獲得できます。`;
  if (count >= 20) {
    medal?.classList.add("gold");
    medal?.classList.remove("silver");
    medal?.classList.remove("bronze");
    medal?.classList.remove("none");
    str = `あと${next(
      40
    )}個でジョーくん帽子<br>プレゼントに応募できます！<br>トロフィーは、パビリオンへの入場や<br class="mobile">クイズに挑戦、<span class="nowrap">ジョーくん</span>を見つけると<br class="mobile">獲得できます。`;
  } else if (count >= 10) {
    medal?.classList.remove("gold");
    medal?.classList.add("silver");
    medal?.classList.remove("bronze");
    medal?.classList.remove("none");
    str = `あと${next(
      20
    )}個で一条ゴールドマイスター<br>トロフィーは、パビリオンへの入場や<br class="mobile">クイズに挑戦、<span class="nowrap">ジョーくん</span>を見つけると<br class="mobile">獲得できます。`;
  } else if (count >= 5) {
    medal?.classList.remove("gold");
    medal?.classList.remove("silver");
    medal?.classList.add("bronze");
    medal?.classList.remove("none");
    str = `あと${next(
      10
    )}個で一条シルバーマイスター<br>トロフィーは、パビリオンへの入場や<br class="mobile">クイズに挑戦、<span class="nowrap">ジョーくん</span>を見つけると<br class="mobile">獲得できます。`;
  } else {
    medal?.classList.remove("gold");
    medal?.classList.remove("silver");
    medal?.classList.remove("bronze");
    medal?.classList.add("none");
  }

  if (count >= 100) {
    point?.classList.add("max");
    str =
      "トロフィーの上限に達しました。<br>100個も集めてくれてありがとうございます！<br>たくさん遊んでくれて本当に嬉しいです！<br>ひきつづき、ジョーズ・タウンをお楽しみください。";
  } else if (count >= 80) {
    str = `あと${next(
      100
    )}個でジョーくん帽子<br>プレゼントに応募できます！<br>トロフィーは、パビリオンへの入場や<br class="mobile">クイズに挑戦、<span class="nowrap">ジョーくん</span>を見つけると<br class="mobile">獲得できます。`;
  } else if (count >= 60) {
    str = `あと${next(
      80
    )}個でジョーくん帽子<br>プレゼントに応募できます！<br>トロフィーは、パビリオンへの入場や<br class="mobile">クイズに挑戦、<span class="nowrap">ジョーくん</span>を見つけると<br class="mobile">獲得できます。`;
  } else if (count >= 40) {
    str = `あと${next(
      60
    )}個でジョーくん帽子<br>プレゼントに応募できます！<br>トロフィーは、パビリオンへの入場や<br class="mobile">クイズに挑戦、<span class="nowrap">ジョーくん</span>を見つけると<br class="mobile">獲得できます。`;
  }

  const desc = document.querySelector<HTMLElement>(".point-desc p");
  if (desc) desc.innerHTML = str;

  const present = document.querySelector<HTMLElement>(
    "header[data-id='park-header'] .present-button"
  );
  if (count >= 20) present?.classList.add("show");
};

(<any>window).receiveCharacterPosition = (x: number, y: number, z: number) => {
  // console.log(`receiveCharacterPosition ${x} ${y} ${z}`);
  const el = document.querySelector<HTMLElement>(".pin.current");
  if (!el) return;

  const p1 = { x: 86, z: 92.6 };
  const p2 = { x: 88.5, z: 93 };
  const p3 = {
    x: (-x + p1.x) / (p1.x + p2.x),
    z: (z + p1.z) / (p1.z + p2.z),
  };

  const m1 = { x: 22, z: 4 };
  const m2 = { x: 77, z: 94 };
  const m3 = { x: m2.x - m1.x, z: m2.z - m1.z };

  const out = { x: m3.x * p3.x + m1.x, z: m3.z * p3.z + m1.z };

  el.style.top = out.z + "%";
  el.style.left = out.x + "%";
};

(<any>window).openPavillionWindow = (
  name: string,
  url: string,
  desc: string
) => {
  const pavillion = document.querySelector<HTMLElement>(
    "#unity-container .pavillion-container"
  );
  if (pavillion) {
    pavillion.classList.add("show");

    (pavillion.querySelector(".desc") as HTMLElement).innerHTML = desc;
    (pavillion.querySelector(".link") as HTMLAnchorElement).setAttribute(
      "data-url",
      url
    );
    (<any>window).pavillionUrl = url;

    const title =
      url.indexOf("technology") !== -1
        ? "テクノロジーミュージアム"
        : url.indexOf("modelhouse") !== -1
        ? "バーチャル展示場"
        : url.indexOf("microdrone") !== -1
        ? "マイクロドローン ルームフライト"
        : url.indexOf("trivia") !== -1
        ? "住まいと暮らしの豆知識"
        : url.indexOf("roomtour") !== -1
        ? "ルームツアー"
        : url.indexOf("realsize") !== -1
        ? "リアルサイズモデルハウス"
        : "";
    (pavillion.querySelector(".title") as HTMLElement).innerText = title;

    const pavillionName =
      title === "テクノロジーミュージアム"
        ? "tech"
        : title === "バーチャル展示場"
        ? "virtual"
        : title === "マイクロドローン ルームフライト"
        ? "drone"
        : title === "住まいと暮らしの豆知識"
        ? "sumai"
        : title === "ルームツアー"
        ? "tour"
        : title === "リアルサイズモデルハウス"
        ? "real"
        : "info";
    (pavillion.querySelector(".room") as HTMLElement).setAttribute(
      "data-name",
      pavillionName
    );
  }
};

(<any>window).openPresentWindow = (count: number) => {
  const container = document.querySelector<HTMLElement>(
    "#unity-container .present-container"
  );
  if (!container || count > 100 || count === undefined) return;
  container.classList.add("show");
  (
    container.querySelector(".desc") as HTMLElement
  ).innerHTML = `トロフィーを${count}個獲得しました！<br>本物のジョーくん帽子に<br>応募しよう！`;
};

(<any>window).showViewWindow = () => {
  store.commit("setIsLoginCampaignWindow", false);
};

const checkCampaignWindow = () => {
  const container = document.querySelector<HTMLElement>(
    "#unity-container .present-container"
  );
  if (container && container.classList.contains("show")) return false;

  if (store.state.postedCampaign) {
    store.commit("setPostedCampaign", false);
    store.commit("setShowPostedCampaign", true);
    return true;
  }

  if (store.state.isLoginCampaignWindow) {
    store.commit("setIsLoginCampaignWindow", false);
    let campaign = store.getters.getNewMemberCampaign;
    if (campaign) {
      store.commit("setSelectCampaign", campaign);
      return true;
    }
    campaign = store.getters.getLoginCampaign;
    if (campaign) {
      store.commit("setSelectCampaign", campaign);
      return true;
    }
  }

  return false;
};

(<any>window).closeTrophyWindow = () => {
  // setTimeout(() => {
  //   checkCampaignWindow();
  // }, 500);
};

let timerId = 0;
(<any>window).statePlayerController = (value: number) => {
  if (timerId !== 0) {
    clearInterval(timerId);
    timerId = 0;
  }

  if (value === 0 || !store.state.ready) {
    return;
  }
  store.commit("setReady", false);

  timerId = setTimeout(() => {
    const isShowWindow = checkCampaignWindow();
    if (!isShowWindow) store.commit("setReadyNotice", true);
  }, 500);
};

(<any>window).openCampaignWindow = (type: string) => {
  if (type !== "LoginCampaign") return;

  const campaign = store.getters.getLoginCampaign;
  if (campaign) {
    // 応募可能
    store.commit("setSelectPostCampaign", campaign);
  } else {
    // 応募済み
    const unityInstance = store.state.unityInstance;
    unityInstance.SendMessage("[GameManager]", "ClosePresentWindow");
  }
};

(<any>window).postPosition = (index: number) => {
  const posts = document.querySelectorAll(`.post.p${index}`);
  if (!posts) return;

  for (const post of posts) {
    post.classList.add("show");
  }
};

(<any>window).openToBlankWindow = () => {
  // const url = (<any>window).pavillionUrl;
  // if (url) window.open(url);
};

(<any>window).started = () => {
  const lastPosition = localStorage.getItem("virtual.last-position");
  if (lastPosition) {
    setTimeout(() => {
      store.state.unityInstance.SendMessage(
        "[GameManager]",
        "SetPositionDisablePopup",
        parseInt(lastPosition)
      );
    }, 100);

    localStorage.removeItem("virtual.last-position");
  }
};

(<any>window).ontouchstart = function () {
  //
};
(<any>window).addEventListener(
  "touchstart",
  function () {
    //
  },
  true
);
(<any>window).addEventListener(
  "touchstart",
  function () {
    //
  },
  false
);
